<h1>Import rewards</h1>

<div class="import-row">
  <input type="file" (change)="onFileSelected($event)" accept=".json">
  <button mat-raised-button color="primary" (click)="importRewardJson()">Import rewards</button>
</div>

@if (!showNotFoundMsg) {
  <div>
    <app-bidirectional-selection [rewardList]="importedRewardsList" [currentSegment]="'import'" (sendRewardList)="getSelectedImports($event)"></app-bidirectional-selection>
  </div>
}

@if (showNotFoundMsg) {
  <div>
    <p>No data...</p>
  </div>
}
